module.exports = __webpack_public_path__ + "img/6.ca576f62.jpg";